import en from './translations/en/Header.json';
import no from './translations/no/Header.json';

type TranslationsType = {
  'en-GB': { [key: string]: string },
  'nb-NO': { [key: string]: string }
}

const translations: TranslationsType = {
  'en-GB': en,
  'nb-NO': no,
};

export { translations, TranslationsType };
